export const savePublicSession = (data) => {
  localStorage.setItem("brandId", data.brandId);
};

export const getPublicSession = () => {
  return {
    brandId: localStorage.getItem("brandId"),
  };
};

export const clearPublicSession = () => {
  localStorage.removeItem("brandId");
};


const GUIDE_KEY = "APP_GUIDE";

export const isGuideDone = (step) => {
  const data = JSON.parse(sessionStorage.getItem(GUIDE_KEY)) || {};
  return data[step];
};

export const setGuideDone = (step) => {
  const data = JSON.parse(sessionStorage.getItem(GUIDE_KEY)) || {};
  data[step] = true;
  sessionStorage.setItem(GUIDE_KEY, JSON.stringify(data));
};

const GUIDE_STORAGE_KEY = "park-guide-progress";

export const saveGuideProgress = (guide) => {
  localStorage.setItem(
    GUIDE_STORAGE_KEY,
    JSON.stringify({
      completedSteps: guide.completedSteps || [],
      skippedSteps: guide.skippedSteps || [],
      currentStep: guide.currentStep || null,
      active: guide.active || false,
    }),
  );
};

export const loadGuideProgress = () => {
  try {
    const data = localStorage.getItem(GUIDE_STORAGE_KEY);

    if (!data) return null;

    return JSON.parse(data);
  } catch {
    return null;
  }
};

export const clearGuideProgress = () => {
  localStorage.removeItem(GUIDE_STORAGE_KEY);
};